module.exports = __webpack_public_path__ + "static/tile-web-solutions-sydney-eeb4924886c3c1f5d53a2c73dbc8ec79.jpg";